import { RaceWagerType } from "@tvg/ts-types/Race";
import { CPPPromo } from "@tvg/design-system/web/components/BetTypeSelector/types";

export enum ShadowSideEnum {
  LEFT = "left",
  RIGHT = "right",
  BOTH = "both"
}

export interface BetTypeSelectorProps {
  wagerTypes?: RaceWagerType[];
  raceWagerType: RaceWagerType | null;
  onSelectWagerType: (wagerType: RaceWagerType) => void;
  raceNumber?: string;
  /**
   * CPP Promo information
   */
  cppPromoObj?: CPPPromo;
  trackCode?: string;
  collapseWidth?: number;
}
